var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.convertYoutube)?_c('iframe',{attrs:{"src":_vm.converted(),"frameborder":"0","webkitAllowFullScreen":"","mozallowfullscreen":"","allowFullScreen":""}}):_c('iframe',{attrs:{"src":_vm.video,"frameborder":"0","webkitAllowFullScreen":"","mozallowfullscreen":"","allowFullScreen":""}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca0298be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/components/apps/video-modal.vue
// module id = yQrP
// module chunks = 0